export default __webpack_public_path__ + "static/previous-seasons-789fd386bba96f8784321d3cbfd5543c.jpg";